<template>
  <router-link :to="link">
    <div class="icon-w">
      <div :class="icon"/>
    </div>
    <p class="title-name-menu">{{ name }}</p>
    <span>{{ name }}</span>
  </router-link>
</template>
<script>
export default {
	name: 'menu-item',
	props: {
		name: {
			type: String,
			required: true
		},
		icon: {
			type: String,
			required: true
		},
		link: {
			type: String,
			required: true
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/app/user/partials/navbar/web/mainMenu/MenuItem.vue